import React from "react";
import {
  Grid,
  FormControl,
  TextField,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button
} from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { DateTimePicker } from "@mui/x-date-pickers-pro";
import moment from "moment";
import dayjs from 'dayjs';
import { MwlEdit, GetMwl } from '../../../../api'

import { MODALITY_OPTIONS } from '../../../../constants/Consult';

export const ModalityWorklistFields = ({ study, required = false, onMWLChange, initialData = {}, modalityOptions }) => {
  const [MWL, setMwl] = React.useState({});

  React.useEffect(() => {
    if (Object.keys(initialData).length > 0) {
      setMwl(initialData);
    }
  }, [initialData]);

  React.useEffect(() => {
    onMWLChange && onMWLChange(MWL);
  }, [MWL, onMWLChange]);

  return (
    <Grid container spacing={3} sx={{ mt: 1, mb: 1 }}>
      <FormControl fullWidth variant="standard">
        <TextField
          name="RequestingPhysician"
          label="Requesting Physician"
          required={required}
          value={MWL.RequestingPhysician || ""}
          onChange={e => setMwl(x => ({ ...x, [e.target.name]: e.target.value }))}
        />
      </FormControl>
      <FormControl fullWidth variant="standard">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DateTimePicker
            label="Scheduled Start Date/Time"
            value={MWL.ScheduledStartDate ? dayjs(moment(MWL.ScheduledStartDate + MWL.ScheduledStartTime, "YYYYMMDDHHmmss")) : null}
            required={required}
            slotProps={{
              textField: {
                required: required,
              },
            }}
            onChange={(newValue) => newValue && setMwl(x => ({ ...x, "ScheduledStartDate": moment(newValue.$d).format("YYYYMMDD"), "ScheduledStartTime": moment(newValue.$d).format("HHmm00") }))}
            textField={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
      </FormControl>
      <FormControl fullWidth variant="standard">
        <TextField
          name="Modality"
          label="Modality"
          select
          value={MWL.Modality || ""}
          onChange={e => setMwl(x => ({ ...x, [e.target.name]: e.target.value }))}
          required={required}
        >
          {(modalityOptions || MODALITY_OPTIONS).map((mod) => (
            <MenuItem key={mod} value={mod}>
              {mod}
            </MenuItem>
          ))}
        </TextField>
      </FormControl>
      <FormControl fullWidth variant="standard">
        <TextField
          name="ProcedureDescription"
          label="Procedure Description"
          value={MWL.ProcedureDescription || ""}
          onChange={e => setMwl(x => ({ ...x, [e.target.name]: e.target.value }))}
          required={required}
        />
      </FormControl>
    </Grid>
  )
};

export const ModalityWorklistDialog = ({ dialogState }) => {
  const { open, onClose, onSend, study, aetitle } = dialogState || {};
  const [mwlData, setMwlData] = React.useState({});

  const handleMWLChange = React.useCallback((data) => {
    setMwlData(data);
  }, []);

  React.useEffect(() => {
    if (study?.modalityWorklist) {
      GetMwl(study.id)
        .then((mwl) => setMwlData(mwl))
    }
    return () => setMwlData({})
  }, [study?.id, study?.modalityWorklist]);

  const handleSave = () => {
    MwlEdit(study.id, {...mwlData, aetitle})
      .then(() => onSend && onSend(dialogState))
  };

  if (!study) return (<React.Fragment />)

  return (
    <Dialog open={open || false} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{study.modalityWorklist ? 'Edit' : 'Create'} Modality Worklist</DialogTitle>
      <DialogContent>
        <ModalityWorklistFields
          study={study || {}}
          required={true}
          onMWLChange={handleMWLChange}
          initialData={mwlData}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleSave} variant="contained">Save</Button>
      </DialogActions>
    </Dialog>
  );
};